import React from 'react';
import './quali.css';

const Quali = () => {
  const education = [
    {
      degree: 'B.Tech in Data Science and Artificial Intelligence',
      institution: 'International Institute of Information Technology (IIIT) Naya Raipur',
      grade: 'CGPA: 9.51',
      period: '2022 - 2026',
      current: true,
    },
    {
      degree: '12th CBSE',
      institution: 'Ryan International School, Raipur',
      grade: 'Grade: 97.2%',
      period: '2020 - 2022',
      current: false,
    },
    {
      degree: '10th CBSE',
      institution: "Bharatiya Vidya Bhavan's R.K Sarda Vidya Mandir, Raipur",
      grade: 'Grade: 95.4%',
      period: '2010 - 2020',
      current: false,
    },
  ];

  return (
    <section className="quali section" id="qualification">
      <div className="container">
        <div className="section__header reveal">
          <span className="section__label">Education</span>
          <h2 className="section__title">Academic Journey</h2>
          <p className="section__subtitle">My educational background and achievements</p>
        </div>

        <div className="quali__timeline reveal">
          {education.map((item, index) => (
            <div className="quali__item" key={index}>
              <div className="quali__marker">
                <div className={`quali__dot ${item.current ? 'quali__dot--active' : ''}`}></div>
                {index < education.length - 1 && <div className="quali__line"></div>}
              </div>
              
              <div className="quali__card">
                {item.current && <span className="quali__badge">Current</span>}
                <h3 className="quali__degree">{item.degree}</h3>
                <p className="quali__institution">{item.institution}</p>
                <div className="quali__meta">
                  <span className="quali__grade">
                    <i className="bx bx-trophy"></i>
                    {item.grade}
                  </span>
                  <span className="quali__period">
                    <i className="bx bx-calendar"></i>
                    {item.period}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Quali;